
// SVG Icon: collapse
export default { id: "terriajs-collapse" };
export const id = "terriajs-collapse";
export const name = "collapse";
